import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=2bd7f02b&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd7f02b')) {
      api.createRecord('2bd7f02b', component.options)
    } else {
      api.reload('2bd7f02b', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=2bd7f02b&", function () {
      api.rerender('2bd7f02b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bhCef0gGyCIB/JS/comp/ImgFallback2.vue"
export default component.exports